import React from 'react';

if (process.env.NODE_ENV === 'development') {
  // TEMPORARILY DISABLED: turn back on when debugging re-renders
  // const whyDidYouRender = require('@welldone-software/why-did-you-render');
  // whyDidYouRender(React, {
  //   logOnDifferentValues: true,
  //   trackAllPureComponents: true,
  //   // Theo dõi tất cả components (bỏ comment để theo dõi tất cả)
  //   // include: [/^.*$/],
  //   // Theo dõi component cụ thể:
  //   // include: [/^SomeComponent$/],
  // });
}
